import { Box, Button } from "@material-ui/core";
import React from "react";
import ChevronLeft from "../icons/chevron-left";
import LocalizedLink from "../localized-link";

type Props = {
  to?: string;
  onClick?: () => void;
  children?: string;
  className?: string;
};

export default function BackButton({
  to,
  onClick,
  children,
  className
}: Props) {
  let targetPath = to;
  if (
    !targetPath &&
    typeof window !== "undefined" &&
    window.history.length <= 2
  ) {
    targetPath = `/user/account/`;
  }

  return (
    <Box marginLeft={-1}>
      <Button
        startIcon={<ChevronLeft />}
        className={`compact ${className}`}
        {...(targetPath
          ? {
              component: LocalizedLink,
              to: targetPath
            }
          : {
              onClick: () => {
                if (onClick) {
                  onClick();
                } else {
                  typeof window !== "undefined" && window.history.back();
                }
              }
            })}
      >
        {children}
      </Button>
    </Box>
  );
}
